import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Component, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Dismiss, DismissOptions, DismissInterface } from 'flowbite';
import { Observable } from 'rxjs';
import { IError } from 'src/app/models/error.model';
import { Store } from '@ngrx/store';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.sass']
})
export class WarningModalComponent implements AfterViewInit {
  dismissInstance: DismissInterface | null = null;
  errorMessage: string = '';
  alertStatus: number = 0;
  faCircleXmark = faCircleXmark;
  faCircleCheck = faCircleCheck;
  soc_id: number = 0;
  animationState: string = 'enter';

  warningPopup: Observable<IError>;

  constructor(private store: Store<{ warningPopup: IError }>) {
    this.warningPopup = store.select('warningPopup');
    this.warningPopup.subscribe((error) => {
      this.errorMessage = error.message;
      this.alertStatus = error.status ?? 0;
      setTimeout(() => {
        this.initiateInstance();
      });
    });
  }

  get isSuccess(): boolean {
    // Treat explicit 2xx statuses as success. Also, if no HTTP status
    // was provided (status === 0) but the message contains common
    // success keywords in Portuguese/English, consider it a success
    // to avoid showing a red alert for successful operations that
    // dispatch only a message (e.g. "Paciente atualizado com sucesso!").
    if (this.alertStatus >= 200 && this.alertStatus < 300) return true;
    if (this.alertStatus === 0 && this.errorMessage) {
      const msg = String(this.errorMessage).toLowerCase();
      const successKeywords = /sucesso|salvo|atualizad[oa]s?|criad[oa]s?|ok|tudo certo|salvo com sucesso/;
      return successKeywords.test(msg);
    }
    return false;
  }

  ngAfterViewInit(): void {
    if (this.errorMessage) {
      this.initiateInstance();
    }
  }

  initiateInstance(): void {
    const $targetEl: HTMLElement | null = document.getElementById('warning-modal');

    if ($targetEl) {
      const instanceOptions = {
        id: 'warning-modal',
        override: true
      };
      if (!this.dismissInstance) {
        const options: DismissOptions = {
          transition: 'transition-opacity',
          duration: 5000,
          timing: 'ease-out',
          onHide: (context, targetEl) => {
            this.animationState = 'leave';
            setTimeout(() => {
              this.store.dispatch(setWarningText('', 0));
              this.animationState = 'enter';
            }, 700); 
            
          }
        };

        this.dismissInstance = new Dismiss($targetEl, null, options, instanceOptions);
      }
      this.startHideTimer();
    }
  }

  dismiss(): void {
    if (this.dismissInstance) {
      this.dismissInstance.hide();
    }
  }

  startHideTimer(): void {
    window.clearTimeout(this.soc_id);
    this.soc_id = window.setTimeout(() => {
      if (this.dismissInstance) {
        this.dismissInstance.hide();
      }
    }, 5000);
  }
}
